import React, { useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { CherryHubAdminApi } from "../../api/adminApiModels";

interface ExtendedFieldDeletionWarningModalProps {
  isOpen: boolean;
  fieldName: string;
  businessId: string;
  registrationForms: CherryHubAdminApi.RegistrationFormConfigurationSummaryItem[];
  onCancel: () => void;
  onConfirm: () => void;
}

export const ExtendedFieldDeletionWarningModal: React.FC<ExtendedFieldDeletionWarningModalProps> =
  ({
    isOpen,
    fieldName,
    businessId,
    registrationForms,
    onCancel,
    onConfirm,
  }) => {
    const cancelRef = useRef<HTMLButtonElement>(null);

    const getStatusTag = (isEnabled?: boolean) => {
      if (isEnabled === true) {
        return (
          <Tag size="sm" colorScheme="green">
            Enabled
          </Tag>
        );
      } else if (isEnabled === false) {
        return (
          <Tag size="sm" colorScheme="gray">
            Disabled
          </Tag>
        );
      }
      return "—";
    };

    return (
      <Modal
        isOpen={isOpen}
        onClose={onCancel}
        initialFocusRef={cancelRef}
        size="2xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Extended Field - Warning</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} alignItems="flex-start">
              <Text>
                The following registration form(s) use the extended field{" "}
                <b>'{fieldName}'</b> as a form field. If you proceed with
                deletion, any values captured will only be retained on the New
                Member Registration form and won't flow through to any Member
                records.
              </Text>

              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th>Form ID</Th>
                    <Th>Form Name</Th>
                    <Th>Status</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {registrationForms.map((form) => (
                    <Tr key={form.Meta?.Id}>
                      <Td>
                        <ChakraLink
                          as={Link}
                          to={`/admin/businesses/${businessId}/registration-form-configurations/${form.Meta?.Id}`}
                          color="blue.500"
                          textDecoration="underline"
                        >
                          {form.Meta?.Id || "—"}
                        </ChakraLink>
                      </Td>
                      <Td>
                        <ChakraLink
                          as={Link}
                          to={`/admin/businesses/${businessId}/registration-form-configurations/${form.Meta?.Id}`}
                          color="blue.500"
                          textDecoration="underline"
                        >
                          {form.DisplayName || "—"}
                        </ChakraLink>
                      </Td>
                      <Td>{getStatusTag(form.IsEnabled)}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button ref={cancelRef} onClick={onCancel}>
              Cancel
            </Button>
            <Button colorScheme="red" ml={3} onClick={onConfirm}>
              Continue with Deletion
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
